import { rate_limit_percentage } from '@shared/constants';
import { Progress, ProgressProps } from 'antd';
import clsx from 'clsx';
import { IconBaseProps } from 'react-icons/lib';
import { RiFlashlightFill } from 'react-icons/ri';

type Props = {
  percent: number;
  iconProps?: IconBaseProps;
} & ProgressProps;

export const progressColor = {
  green: '#34d399',
  yellow: '#FBBF24',
  red: '#F87171',
};

export function getStrokeColor(percent: number): 'green' | 'yellow' | 'red' {
  if (percent <= rate_limit_percentage.green) return 'green';
  if (percent <= rate_limit_percentage.yellow) return 'yellow';
  return 'red';
}

export function AppProgressBarCircle(props: Props) {
  const { percent, iconProps = {}, size = 24, ...restProps } = props;
  const strokeColor = getStrokeColor(percent);

  return (
    <Progress
      type="circle"
      percent={percent}
      size={size}
      strokeWidth={15}
      format={() => <RiFlashlightFill size={14} color="white" className="m-auto" {...iconProps} />}
      trailColor="var(--color-gray-400)"
      strokeColor={
        strokeColor == 'green'
          ? progressColor.green
          : strokeColor === 'yellow'
            ? progressColor.yellow
            : progressColor.red
      }
      className={clsx('app-progress [&>.ant-progress-inner]:-translate-y-0.5', strokeColor)}
      style={{
        height: size as number,
      }}
      {...restProps}
    />
  );
}
